import React, { FC, useCallback, useEffect, useState } from 'react';
import { UserAvatar, UserNameView } from '../../../../../components/atoms/UserAvatar';
import { Space, Tag } from 'antd';
import { AutoCompleteInput } from '../../../../../form/adapters/AutoCompleteInput';
import { useConnection } from '../../../../../connection/Application';

type Props = {
  cycle: number;
  userId: number;
  teamId: number;
  firstName: string;
  lastName: string;
  image: string;
  goalSummaryId: number;
  members: any[];
  leader: boolean;
  values: { reviewer: number; status: string }[];
  displayLabel: string;
};

export const TeamUserPage: FC<Props> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    cycle,
    userId,
    teamId,
    firstName,
    lastName,
    image,
    members,
    goalSummaryId,
    values,
    leader,
    displayLabel,
  } = props;
  const [value, setValue] = useState<number[]>([]);
  const [statuses, setStatuses] = useState<Record<number, string>>({});

  const connection = useConnection();
  const peerSchema = {
    values: members.map((e) => ({
      id: e.id,
      image: e.image,
      value: `${e.firstName} ${e.lastName}`,
    })),
    // eslint-disable-next-line react/display-name
    itemView: (value: any) => (
      <Space>
        <UserAvatar src={value?.image} />
        {value?.value}
      </Space>
    ),
  };
  useEffect(() => {
    setValue(values.map((v) => v.reviewer));
    const statusMap: Record<number, string> = {};
    values.forEach((v) => {
      statusMap[v.reviewer] = v.status;
    });
    setStatuses(statusMap);
  }, [values]);

  const tagRender = (props: any) => {
    const { label, value, closable, onClose } = props;
    const isRemovable = statuses[value] === 'not submitted' || !statuses[value];
    return (
      <Tag
        closable={closable && isRemovable}
        onClose={onClose}
        style={{ marginRight: 3 }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}>
        {label}
      </Tag>
    );
  };

  const setPeers = useCallback(
    (e) => {
      connection
        .patch(`goals/setPeers/${goalSummaryId}/${userId}`, {
          reviewers: e,
          cycleId: cycle,
          teamId: teamId,
          leader: leader,
        })
        .then(() => {
          // console.log(val);
        });
    },
    [connection, cycle, goalSummaryId, leader, teamId, userId],
  );

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px 20px 20px',
      }}>
      <div style={{ flex: 2 }}>
        <UserNameView name={`${firstName} ${lastName}`} src={image} tags={false} />
      </div>
      <div style={{ flex: 6, alignItems: 'center' }}>
        {`${displayLabel}`}
        <AutoCompleteInput
          mode={'multiple'}
          {...peerSchema}
          style={{ width: '100%' }}
          value={value}
          onChange={(e) => setValue(e)}
          onBlur={() => setPeers(value)}
          tagRender={tagRender}
        />
      </div>
    </div>
  );
};
